module.exports = __webpack_public_path__ + "img/09.56f705fa.png";